import React from 'react';

let MHLManager  = require('../Managers/MHL');
let Quote       = require('../Managers/Quote');
let FaSpinner   = require('react-icons/lib/fa/spinner');
let HttpService = require('../Managers/HttpService');

const Config = HttpService.getConfigForHost();
const MHLModal = React.createClass({
    propTypes: {
        closeFunction: React.PropTypes.func.isRequired,
        hideLogin: React.PropTypes.func,
        mountCustomerDetails: React.PropTypes.func,
        getEmail: React.PropTypes.func
    },

    getInitialState() {
        return {
            isLoggingIn: false,
            errorEmail: false,
            isErrorMessage : false,
        };
    },

    componentWillReceiveProps() {
        this.setState({ isErrorMessage : false });
    },

    isValidEmail(email) {
        let regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        let t = regex.test(email);
        this.setState({
            errorEmail: (t) ? false : true
        });

        return t;
    },

    sendAccountValidation() {
        if (this.isValidEmail(this.refs.identity.value)) {
            MHLManager.resendValidationEmail(Config.mhl.resendValidation.url, this.refs.identity.value);
        }
    },

    resetPassword() {
        MHLManager.resetPassword(Config.mhl.resetPassword.url, this.refs.identity.value);
    },

    showErrorMessage() {
        this.setState({
            isErrorMessage : true
        });
    },

    doLogin() {
        let email = this.props.getEmail();
        if (! this.isValidEmail(email)) {
            return false;
        }
        let _this = this;

        this.setState({
            isLoggingIn : true
        });

        MHLManager.login(Config.mhl.login.url, email, this.refs.credential.value).then(
            function(s, textStatus, xhr) {
                _this.setState({
                    isLoggingIn : false
                });
                if (xhr.status == 200) {
                    // login was valid
                    _this.props.mountCustomerDetails(s.customer_details);
                    _this.props.hideLogin();
                } else {
                    // login was invalid
                    _this.showErrorMessage();
                    Quote.set('is_logged_into_myhomelet', false);
                }
            },
            function() {
                // something went wrong, we're definitely not logged in
                _this.showErrorMessage();
                _this.setState({
                    isLoggingIn : false
                });
                _this.props.forceRerender();
                _this.props.clearEmail();
                Quote.set('is_logged_into_myhomelet', false);
            }
        );
    },

    render() {
        return (
            <div className="full-width">
                {this.state.isErrorMessage ?
                    <div className="flash modal-flash error standalone">
                        Your password is incorrect.
                    </div>
                : null}
                <p>Your email is already registered to My HomeLet, please provide your password to continue your quotation.</p>
                <question-row>
                    <div className="question-main">
                        <div className="question-top">
                            <label>Password</label>
                        </div>
                        <div className="question-input">
                            <input type="password" name="credential" ref="credential" />
                        </div>
                    </div>
                </question-row>

                <button className="btn btn-success" onClick={this.doLogin}>Sign in {this.state.isLoggingIn ? <FaSpinner className="spin" /> : null}</button>

                <div className="reset-bar">
                    <p>
                        <a className="underline primary-colour" href="https://homelet.co.uk/my-homelet/login" target="_blank">Forgot password</a>
                    </p>
                </div>
            </div>
        );
    }
});

export default MHLModal;



/** WEBPACK FOOTER **
 ** ./src/components/Modals/MHLModal.js
 **/